import _defineProperty from '../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import { flip, indexOf, curry, compose, cond, prop, always, T, applySpec, equals } from 'ramda';
import '../utils/createTimeline.js';
import '../utils/convertAxisListToTiles.js';
import '../utils/convertAxisToTile.js';
import '../utils/parseCode.js';
import '../utils/detectDarkTile.js';
import '../utils/detectPiece.js';
import '../utils/detectOpponent.js';
import '../utils/detectMoved.js';
import '../utils/detectEnemyOnTiles.js';
import '../utils/detectTurn.js';
import '../utils/detectContacted.js';
import '../utils/findCode.js';
import '../utils/findCodeByTile.js';
import '../utils/findOpponentKing.js';
import '../utils/getNextFileByIndex.js';
import '../utils/getNextRankByIndex.js';
import '../utils/getPKeyByTile.js';
import '../utils/getEqualPieces.js';
import '../utils/getSymmetryTile.js';
import '../utils/getAnimationAxis.js';
import '../utils/getDirection.js';
import '../utils/getTilesDifference.js';
import parseTile from '../utils/parseTile.js';
import '../utils/removeDirection.js';
import '../utils/removeCodeByTile.js';
import '../utils/replaceCode.js';
import { Rank } from '../presets/terms.js';
import { Side } from '../presets/rules.js';
import '../utils/validateTile.js';
import '../utils/filterOpponent.js';
import '../utils/computeDistance.js';
import '../utils/pretendTo.js';
import '../utils/transformInto.js';
import '../utils/diffSnapshot.js';
import '../utils/subInBetweenIndexes.js';

var _indexOf=flip(indexOf);function getPromotionCode(e,r,o){var p;return compose(cond([[prop(o),always("".concat(o).concat(e).concat(r))],[T,always("")]]),applySpec((_defineProperty(p={},Side.w,equals(0)),_defineProperty(p,Side.b,equals(Rank.length-1)),p)),_indexOf(Rank),Number,prop("rankName"),parseTile)(r)}var getPromotionCode$1 = curry(getPromotionCode);

export { getPromotionCode$1 as default };
//# sourceMappingURL=getPromotionCode.js.map
